<template>
  <TirPmOptionListItemElement :is-hoverable="!isDisabled">
    <div :class="['tir-pm-search-input-content-line', {'is-disabled': isDisabled}]">
      <div class="tir-pm-search-input-content-line__left-slot" v-if="isWithLeftSlot">
        <slot name="leftSlot"></slot>
      </div>

      <div class="tir-pm-search-input-content-line__text">
        <slot></slot>
      </div>

      <div class="tir-pm-search-input-content-line__right-slot" v-if="isWithRightSlot">
        <slot name="rightSlot"></slot>
      </div>
    </div>
  </TirPmOptionListItemElement>
</template>

<script lang="ts" setup>
import { computed, defineProps, PropType, useSlots } from "vue";
import { TirPmOptionListItemElement } from "tir-pm-option-list";

const slots = useSlots();
/**
 * Есть ли слот для хедера
 */
const isWithLeftSlot = computed(() => slots && slots.leftSlot && slots.leftSlot());
/**
 * Есть ли слот для правой области
 */
const isWithRightSlot = computed(() => slots && slots.leftSlot && slots.leftSlot());

/**
 * Пропсы
 */
const props = defineProps({
  /**Дизейбл */
  isDisabled: {
    type: Boolean,
    default: false
  },
});
</script>
